/*
 * Public API Surface of ngx-dynamic-table
 */

export * from './lib/ngx-dynamic-table.service';
export * from './lib/ngx-dynamic-table.component';
export * from './lib/ngx-dynamic-table.module';
